// extracted by mini-css-extract-plugin
export var aboveInput = "_j9-0";
export var actionButton = "_j9-5";
export var actionButtonContainer = "_j9-1";
export var actionIcon = "_j9-6";
export var aiInfoContainer = "_j9-2";
export var attachmentWrapper = "_j9-7";
export var bold = "_j9-3";
export var checkIcon = "_j9-8";
export var clickingRecipientBar = "_j9-11";
export var commentThreadSwitch = "_j9-a";
export var draftImage = "_j9-b";
export var draftImageContainer = "_j9-c";
export var draftImages = "_j9-e";
export var editButton = "_j9-g";
export var editor = "_j9-f";
export var editorContainer = "_j9-y";
export var editorErrorTooltipWrapper = "_j9-9";
export var headerDivider = "_j9-h";
export var icon = "_j9-i";
export var info = "_j9-j";
export var internal = "_j9-n";
export var internalDivider = "_j9-k";
export var internalMessage = "_j9-l";
export var messageInputCard = "_j9-m";
export var messageInputForm = "_j9-o";
export var messageInputFormInternal = "_j9-p";
export var options = "_j9-q";
export var publicMessageCustomer = "_j9-s";
export var publicMessageMerchant = "_j9-r";
export var removeImageButton = "_j9-d";
export var replyButtons = "_j9-t";
export var showSignatureButton = "_j9-u";
export var spinner = "_j9-v";
export var verticalButtonDivider = "_j9-4";
export var visibilitySelector = "_j9-w";
export var warning = "_j9-x";
export var wrappingText = "_j9-z";
export var writingInternalNoteTopBorder = "_j9-10";